export const getAtoms = flows => {
  return flows.reduce((sum, flow) => {
    return flow?.atoms ? [...sum, ...flow.atoms] : sum
  }, [])
}
